module.exports = __webpack_public_path__ + "img/icon_or.a98919c7.png";